import { mediaData } from '@/mocks/homeData';

const thumbnailImages = [
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20dynamic%20energy%20waves%20representing%20highlight%20reel%2C%20modern%20cinematic%20composition%20with%20motion%20blur%20effects%2C%20video%20thumbnail%20aesthetic%2C%20soft%20gradient%20background%2C%20professional%20editorial%20quality&width=640&height=360&seq=media-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20geometric%20flowing%20chart%20and%20ranking%20visual%2C%20modern%20minimalist%20design%2C%20cinematic%20lighting%2C%20soft%20atmospheric%20depth%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20rose%20and%20gold%20retrospective%20collage%20with%20soft%20overlapping%20elements%2C%20modern%20art%20style%2C%20cinematic%20composition%2C%20editorial%20video%20thumbnail%20aesthetic&width=640&height=360&seq=media-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20terracotta%20and%20peach%20behind%20the%20scenes%20mood%2C%20soft%20organic%20shapes%20with%20cinematic%20lighting%2C%20modern%20minimalist%20editorial%20design%2C%20video%20thumbnail%20aesthetic&width=640&height=360&seq=media-4&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">热门视频</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200/60"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={thumbnailImages[idx] || thumbnailImages[0]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-background-950/70 text-white backdrop-blur-sm whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-2 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-400">{item.views}次播放</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}